import { cloudFrontURL } from '../config/endpoints'

function getAssetsFile(clientId, assetId) {
  return `${cloudFrontURL}${clientId}/${assetId}`
}

export { getAssetsFile }
